import { useEffect } from "react";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

export function useSeo({ title, description, image, jsonLd }) {
  useEffect(() => {
    const full = title ? `${title} | CASABLANCA` : "CASABLANCA — Premium Sneakers & Streetwear";
    document.title = full;
    if (description) { setMeta("name", "description", description); setMeta("property", "og:description", description); }
    setMeta("property", "og:title", full);
    setMeta("property", "og:url", window.location.href);
    if (image) setMeta("property", "og:image", image);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = window.location.origin + window.location.pathname;
    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.seo = "1";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => { if (script) script.remove(); };
  }, [title, description, image, jsonLd]);
}
